import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addCategory, addSubcategory, getCategories } from 'slice/categorySlice';
import { toast } from 'react-toastify';

const Add = () => {
  const dispatch = useDispatch();
  const { categories, loading } = useSelector((state) => state.category);

  const [categoryName, setCategoryName] = useState('');
  const [subcategoryForm, setSubcategoryForm] = useState({
    category_id: '',
    name: ''
  });

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  const handleCategorySubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(addCategory({ name: categoryName.trim() })).unwrap?.();
      toast.success('Category added successfully!');
      setCategoryName('');
    } catch (error) {
      console.error('Category add failed:', error);
      toast.error('Failed to add category');
    }
  };

  const handleSubcategorySubmit = async (e) => {
    e.preventDefault();
    if (!subcategoryForm.category_id) {
      toast.error('Please select a category');
      return;
    }
    try {
      await dispatch(
        addSubcategory({
          category_id: subcategoryForm.category_id,
          name: subcategoryForm.name.trim()
        })
      ).unwrap?.();
      toast.success('Sub-category added successfully!');
      setSubcategoryForm({ category_id: '', name: '' });
    } catch (error) {
      console.error('Sub-category add failed:', error);
      toast.error('Failed to add sub-category');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Category</h4>
      </div>

      {/* ================= ADD CATEGORY ================= */}
      <form onSubmit={handleCategorySubmit}>
        <div className="row mx-4">
          <div className="col-sm-12 mt-2">
            <label htmlFor="categoryName" className="adminlables">
              Category Name
            </label>
            <input
              type="text"
              id="categoryName"
              className="form-control"
              placeholder="e.g. Politics"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="mt-4 text-right mx-5">
          <button className="btn addbtn btn-lg" disabled={loading} type="submit">
            {loading ? 'Adding...' : 'Add Category'}
          </button>
        </div>
      </form>

      {/* ================= ADD SUB-CATEGORY ================= */}
      <div className="mainheadig mx-4 mt-5">
        <h4 className="text-white font-weight-bold">Add Sub-Category</h4>
      </div>

      <form onSubmit={handleSubcategorySubmit}>
        <div className="row mx-4">
          <div className="col-sm-12 col-md-6 mt-2">
            <label htmlFor="parentCategory" className="adminlables">
              Parent Category
            </label>
            <select
              id="parentCategory"
              className="form-control"
              value={subcategoryForm.category_id}
              onChange={(e) => setSubcategoryForm({ ...subcategoryForm, category_id: e.target.value })}
              required
            >
              <option value="">Select Category</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-sm-12 col-md-6 mt-2">
            <label htmlFor="subcategoryName" className="adminlables">
              Sub-Category Name
            </label>
            <input
              type="text"
              id="subcategoryName"
              className="form-control"
              placeholder="e.g. State Politics"
              value={subcategoryForm.name}
              onChange={(e) => setSubcategoryForm({ ...subcategoryForm, name: e.target.value })}
              required
            />
          </div>
        </div>
        <div className="mt-4 text-right mx-5">
          <button className="btn addbtn btn-lg" disabled={loading} type="submit">
            {loading ? 'Adding...' : 'Add Sub-Category'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Add;